// Enterprise tenant configuration
// Detects tenant from hostname and provides branding config

const TENANTS = {
  'villarreal': {
    slug: 'villarreal',
    name: 'Villarreal Academy',
    primaryColor: '#FFD700',
    secondaryColor: '#1B2A4A',
    accentColor: '#FFC107',
    bgDark: '#0D1B2A',
    bgCard: '#132338',
    borderColor: '#1E3350',
    textPrimary: '#FFD700',
    logoUrl: 'https://customer-assets.emergentagent.com/job_560a82f5-d842-4ce7-9063-cdf20d9214d7/artifacts/dnhpwlob_image.png',
    badgeUrl: 'https://customer-assets.emergentagent.com/job_560a82f5-d842-4ce7-9063-cdf20d9214d7/artifacts/epzg45go_image.png',
    loginTitle: 'VILLARREAL ACADEMY',
    loginSubtitle: 'Plataforma oficial de gestión deportiva',
    welcomeText: 'Bienvenido al sistema de Villarreal Academy',
    sidebarTitle: 'Villarreal Academy',
    hostnames: ['villarreal.micoach.tech', 'villarreal.localhost'],
  },
};

export function detectTenant() {
  const hostname = window.location.hostname;
  const search = window.location.search;
  
  // 1. Exact hostname match (villarreal.micoach.tech)
  for (const [slug, config] of Object.entries(TENANTS)) {
    if (config.hostnames.some(h => hostname === h)) {
      return config;
    }
  }
  
  // 2. Subdomain detection (villarreal.anything.com → matches 'villarreal')
  const subdomain = hostname.split('.')[0];
  if (TENANTS[subdomain]) {
    return TENANTS[subdomain];
  }
  
  // 3. URL param (development: ?tenant=villarreal)
  const params = new URLSearchParams(search);
  const tenantParam = params.get('tenant');
  if (tenantParam && TENANTS[tenantParam]) {
    return TENANTS[tenantParam];
  }
  
  // 4. localStorage persistence
  const saved = localStorage.getItem('micoach_tenant');
  if (saved && TENANTS[saved]) {
    return TENANTS[saved];
  }
  
  return null;
}

// Persist tenant when detected via URL param
const _initialTenant = detectTenant();
if (_initialTenant) {
  localStorage.setItem('micoach_tenant', _initialTenant.slug);
}

export function getTenantConfig(slug) {
  return TENANTS[slug] || null;
}

export function isEnterpriseTenant() {
  return detectTenant() !== null;
}

export default TENANTS;
